import axios from '../request/http';
import { toFormData } from '../common/descriptions';

const article = {
    // 获取文章列表
    articleQueryAllList(params) {
        return axios.get("/service-article/article/queryAllList", { params });
    },
    // 文章分类列表
    articleCategoryList(params) {
        return axios.get("/hemei-admin/category/article/list", { params });
    },
    // 话题列表
    topicList(params) {
        return axios.get("/service-article/topic/getList", { params });
    },
    // 文章审核
    articleDoReview(params) {
        return axios.get("/service-article/article/doReview", { params });
    },
    // 移除电商管理员
    delManageAccount(data) {
        return axios.post("/hemei-admin/accountManage/village/delManageAccount", toFormData(data));
    },
    // 添加电商管理员
    accountManage(data) {
        return axios.post("/hemei-admin/accountManage/village/manage", data);
    },

    //端文章发布编辑

    admincreate(params) {
        return axios.post('/service-article/article/admin/create', (params))
    },
    // // 获取平台话题

    getTopics(params) {
        return axios.get('/service-article/topic/getTopics', { params })
    },
}

export default article;


// WEBPACK FOOTER //
// ./src/api/article.js